import { useEffect, useRef } from 'react';
import { t } from '@/i18n/i18n';
import { useNavigate } from 'react-router-dom';
import { useAccess } from '@/access/useAccess';
import { useAuth } from '@/auth/AuthProvider';
import { useToast } from '@/app/toasts/ToastProvider';
import { storageKeys } from '@/config/app';
import { session } from '@/lib/storage';
import { decideSubscribeIntent } from './billingState';
import { usePaywall } from './PaywallContext';

/**
 * Довести намерение `?action=subscribe&plan=` (уже в sessionStorage, см. urlActions)
 * до Paddle (BILL-3): переживает вход, регистрацию и код; стирается в бесплатном
 * режиме и при уже активной подписке (тогда — в Billing).
 */
export function useSubscribeIntent(): void {
  const { user, isAuthenticated } = useAuth();
  const access = useAccess();
  const { openPaywall } = usePaywall();
  const navigate = useNavigate();
  const toast = useToast();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    const raw = session.get(storageKeys.pendingPlan);
    const pending = raw === 'monthly' || raw === 'yearly' ? raw : null;
    const decision = decideSubscribeIntent({ pending, access, user, isAuthenticated });
    if (decision === 'none' || decision === 'wait') return;
    session.remove(storageKeys.pendingPlan);
    done.current = true;
    if (decision === 'drop') return;
    if (decision === 'billing') {
      toast.show(t('billing.alreadySubscribed'));
      navigate('/billing');
      return;
    }
    openPaywall({ trigger: 'landing_intent', source: 'landing', plan: pending!, autoStart: true });
  }, [user, isAuthenticated, access, openPaywall, navigate, toast]);
}
